import { Typography, TypographyProps } from '@mui/material';

export const Title = ({ variant = 'body1', children, ...props }: TypographyProps) => {
    return (
        <Typography variant={variant} {...props}>
            {children}
        </Typography>
    );
};
